import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
  selector: "gem-skeleton",
  styleUrls: ["gem-skeleton.component.scss"],
  template: "",
  host: {
    "[class.circle]": "variant === 'circle'",
    "[style.width]": "width",
    "[style.height]": "height",
    "aria-hidden": "true",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class GemSkeletonComponent {
  @Input() variant: "text" | "rect" | "circle" = "text";
  @Input() width = "100%";
  @Input() height = "1rem";
}
